/**
 * Active-stream presence lease. The viewer renews this while its watch screen
 * is alive; an abandoned/crashed player therefore stops blocking the account
 * after a few minutes instead of looking active for an entire recital.
 */
export const PLAYBACK_SESSION_TTL_SECONDS = 5 * 60;
/** How often an active viewer renews its presence lease. */
export const PLAYBACK_SESSION_HEARTBEAT_SECONDS = 60;
/** Recent-progress window used by the admin dashboard's "Watching now" count. */
export const PLAYBACK_ACTIVITY_TTL_SECONDS = 90;
export function isPlaybackActivityRecent(lastPlaybackActivityAt, nowMs = Date.now()) {
    if (typeof lastPlaybackActivityAt !== "string")
        return false;
    const activityMs = Date.parse(lastPlaybackActivityAt);
    return (Number.isFinite(activityMs) &&
        activityMs <= nowMs + 5_000 &&
        activityMs > nowMs - PLAYBACK_ACTIVITY_TTL_SECONDS * 1000);
}
/** Signed URL TTL — long enough that a dance or cast never dies mid-play. */
export const PLAYBACK_URL_TTL_SECONDS = 2 * 60 * 60;
/** Browse-art token TTL — covers and thumbs for a long browsing session. */
export const BROWSE_ART_TTL_SECONDS = 6 * 60 * 60;
